import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { SIDEBAR_CONFIG } from './sidebar.config';
import { NavigationEnd, Router } from '@angular/router';
import { NavItem } from '../../interfaces';
import { LocalStorageService } from '@app/services';
import { APP_ROUTES } from '@app/constants';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() isOpen: boolean = false;
  menu: any[] = []
  activeRoute: string;
  userName: string;
  isProfileMenuOpen: boolean = false;

  logo: string;
  @ViewChild('sidebar') elementRef: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: any): void {
     if (!this.elementRef.nativeElement.contains(event.target)) {  
      this.isProfileMenuOpen = false;
     }
  }

  constructor(private router: Router) { }

  public ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActiveRoute()
      }
    });
    this.menu = SIDEBAR_CONFIG[
      LocalStorageService.getUserRole()
    ]
    this.userName = LocalStorageService.getUserName();
    this.logo = LocalStorageService.getLogo();
    
    this.setActiveRoute()
  }

  navToggle() {
    this.isOpen = !this.isOpen
  }

  redirectTo(navItem: NavItem) {
    this.router.navigate([navItem.path]);
  }

  setActiveRoute() {
    for(let route of Object.values(APP_ROUTES)){
      if (this.router.url.includes(route)) this.activeRoute = `/${route}`;
    }
  }

  logOut() {
    LocalStorageService.clearSession();
    this.router.navigate([APP_ROUTES.LOGIN]);
  }
}
